// Validação pragmática de e-mail. Não tenta cobrir 100% da RFC 5322 — pega
// 99,9% dos casos reais (local@dominio.tld) e rejeita o que é óbvio lixo.
// Validação definitiva é o backend enviar e-mail e ver se chega.

const RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function validateEmail(input) {
    if (input == null) return { valid: false, error: 'Informe o e-mail.' };

    const email = String(input).trim();
    if (email.length === 0) return { valid: false, error: 'Informe o e-mail.' };
    if (email.length > 254) return { valid: false, error: 'E-mail muito longo.' };
    if (!RE_EMAIL.test(email)) return { valid: false, error: 'E-mail inválido.' };

    return { valid: true };
}

// Provedores aceitos no CADASTRO de email novo. O ZeptoMail tem entrega
// instável pra Yahoo e provedores desconhecidos, então só liberamos os grandes.
// (Espelha a allowlist do backend em uenserver/src/utils/emailProvedor.js —
// mantenha as duas em sincronia.)
export const PROVEDORES_PERMITIDOS = [
    'gmail.com',
    'icloud.com',
    'hotmail.com', 'hotmail.com.br',
    'outlook.com', 'outlook.com.br',
    'live.com', 'live.com.br',
    'bol.com.br',
];

const MSG_PROVEDOR =
    'Use Gmail, iCloud, Hotmail, Outlook, Live ou BOL. Outros provedores (como Yahoo) não são aceitos.';

// Valida formato E provedor — para a ENTRADA de email novo (cadastro). Não usar
// em login/recuperação de senha, onde o usuário digita um email já existente
// (que pode ser de outro provedor cadastrado no passado).
export function validateEmailCadastro(input) {
    const base = validateEmail(input);
    if (!base.valid) return base;

    const dominio = String(input).trim().toLowerCase().split('@')[1] || '';
    if (!PROVEDORES_PERMITIDOS.includes(dominio)) {
        return { valid: false, error: MSG_PROVEDOR };
    }
    return { valid: true };
}
